import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { SelectedCard, cardCheckActions, CardQuery, CardOptionQuery, BinNumberQuery } from '@awp/nac/card-check/api';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { isNullOrEmpty } from '@awp/core/utils';
import { ApiInsuranceType } from '@awp/quote/models';
import { BinCheckComponent } from '../bin-check/bin-check.component';

@Component({
  selector: 'ap-card-check',
  templateUrl: './card-check.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CardCheckComponent implements OnInit, OnDestroy {

  selectedCard: SelectedCard;
  contentData: any;
  showBinNotFound: boolean = false;
  showAlternativeBinFound: boolean = false;

  private _context: any;
  get context(): any {
    return this._context;
  }
  set context(value: any) {
    this._context = value;
    if (this.binCheckComponent != null) {
      this.binCheckComponent.clearBin();
    }
    this.changeDetectorRef.markForCheck();
  }

  @ViewChild(BinCheckComponent, { static: false }) binCheckComponent: BinCheckComponent;

  constructor(
    public cardQuery: CardQuery,
    public cardOptionQuery: CardOptionQuery,
    public binQuery: BinNumberQuery,
    private store: Store<any>,
    private changeDetectorRef: ChangeDetectorRef,
    private contentProvider: ContentProvider) { }

  ngOnInit(): void {

    // PreFetch benefits
    this.contentProvider.preFetchContent(['benefitTables'])
      .pipe(
        take(1),
        catchError(err => of(null)))
      .subscribe();

    this.binQuery.values
      .pipe(untilDestroyed(this))
      .subscribe(p => {
        this.showBinNotFound = (!isNullOrEmpty(p.binNumber) && p.binFound === false);
        this.showAlternativeBinFound = (!isNullOrEmpty(p.binNumber) && p.alternativeBin === true);
      });
  }

  ngOnDestroy(): void { }

  onCardSelected(card: SelectedCard): void {
    this.selectedCard = card;
    this.contentData = {
        cardName: card.cardType.description,
        coverlevel: card.cardType.code
      };

    if (card.cardType.code == null) {
      let insuranceType = this.getInsuranceType();
      let errorCode = insuranceType === ApiInsuranceType.TravelInsurance ?  'PLAN_NOT_FOUND' : 'OTHER_INSURANCES_PLAN_NOT_FOUND';
      this.store.dispatch(new cardCheckActions.SelectCardTypeFailureAction( insuranceType ));
    }

  }

  onBinSearch(bin: string): void {
    this.store.dispatch(new cardCheckActions.BinSearchAction(bin, this.getInsuranceType()));
  }

  resetBin(): void {
    this.store.dispatch(new cardCheckActions.ResetBinSearch());
    this.showBinNotFound = false;
    this.selectedCard = null;
    this.showAlternativeBinFound = false;
  }

  private getInsuranceType() {
    switch (this._context.content.productName) {
      case "travelInsurance":
          return ApiInsuranceType.TravelInsurance;
      case "otherInsurance":
          return ApiInsuranceType.OtherInsurances;
      default:
          throw new Error('Expected travelInsurance or otherInsurance. Got "' + this._context.content.productName + '"');
    }
  }

  onClearAlternativeBinError(): void {
    this.showAlternativeBinFound = false;
  }
}
